import { UPDATEORDERSTATUS, AcceptOrder } from '../../api/apiConfig';
import { apiPost } from '../../utils/services';

export const updateOrderStatus = data => {
    return apiPost(UPDATEORDERSTATUS, data);
};

export const acceptOrder = data => {
    return apiPost(AcceptOrder, data);
};
